<div class="alert">
  <img class="alert__icon" [src]="iconExclaim" alt="Icon_exclaim" />
  <div class="alert__info">
    <h3 class="alert__primary-text">
      {{ primaryText }}
    </h3>
    <p class="alert__secondary-text">{{ secondaryText }}</p>
  </div>
</div>
